import type { AdminPanelStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<AdminPanelStyles, SxProps<Theme>> => {
  return {
    cardRoot: { mt: 3, width: "50%" },

    searchBarContent: {
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      gap: 4,
    },

    searchBarButton: { minWidth: "10%" },
  };
};

export default getStyles;
